import React, { useState, useEffect, useCallback } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Row, Col, Typography } from "antd";

import Service from "./service";
import ServiceWithParameter from "./serviceWithParameter";
import { getEntity } from "../../../modules/crudOperations";
import ConsignmentPriceItem from "../../app/generic/consignmentPriceItem";

const formatPrice = (price) =>
  price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");

function Insurance({
  adr,
  rules,
  product,
  disabled,
  currencies,
  formItemLayout,
  initialServices,
  getFieldDecorator,
  disableCurrencySet,
  deliveryCountryCurrencies,
}) {
  const intl = useIntl();

  const [insurance, setInsurance] = useState(
    initialServices && initialServices.insurance
  );
  const handleSetInsurance = useCallback(
    (e) => setInsurance(e.target.checked),
    []
  );

  const [insuranceDetail, setInsuranceDetail] = useState(
    initialServices && initialServices.insuranceDetail
  );
  const [consignmentPrice, setConsignmentPrice] = useState(
    initialServices && initialServices.consignmentPrice
  );
  const [consignmentPriceCurrency, setConsignmentPriceCurrency] = useState(
    initialServices && initialServices.consignmentPriceCurrency
  );
  const [maxPrice, setMaxPrice] = useState();
  const [limitPrice, setLimitPrice] = useState();

  useEffect(() => {
    insurance && consignmentPrice
      ? getEntity(
          "consignment/insurance-price",
          undefined,
          undefined,
          setInsuranceDetail,
          {
            adr: adr === true,
            consignmentPrice,
            currency: consignmentPriceCurrency && consignmentPriceCurrency.code,
          }
        )
      : setInsuranceDetail();
  }, [adr, insurance, consignmentPrice, consignmentPriceCurrency]);

  const overPrice = maxPrice && consignmentPrice > maxPrice;

  return (
    <>
      <ServiceWithParameter
        special
        wrapperSpan={10}
        label={intl.formatMessage({
          id: "consignment.services.price",
          defaultMessage: "Hodnota zásilky",
        })}
      >
        <ConsignmentPriceItem
          noMaxValue
          inlineLabel
          product={product}
          labelValue="&nbsp;"
          disabled={disabled}
          onMaxSet={setMaxPrice}
          currencies={currencies}
          onLimitSet={setLimitPrice}
          formItemLayout={formItemLayout}
          initialServices={initialServices}
          getFieldDecorator={getFieldDecorator}
          disableCurrencySet={disableCurrencySet}
          onConsignmentPriceChange={setConsignmentPrice}
          currencyClassName="services-form-currency-select"
          deliveryCountryCurrencies={deliveryCountryCurrencies}
          onConsignmentPriceCurrencyChange={setConsignmentPriceCurrency}
          error={
            overPrice ? (
              <FormattedMessage
                id="consignment.insurance.overPrice.error"
                values={{
                  price: formatPrice(maxPrice),
                }}
                defaultMessage="Překročeno maximum {price}"
              />
            ) : undefined
          }
        />
      </ServiceWithParameter>
      {!insurance &&
        maxPrice &&
        limitPrice &&
        consignmentPrice > limitPrice &&
        consignmentPrice <= maxPrice && (
          <Row gutter={[0, 20]}>
            <Col offset={3}>
              <Typography.Text type="danger" className="insurance-warning">
                <FormattedMessage
                  id="consignment.insurance.recommendation"
                  values={{
                    price: formatPrice(limitPrice),
                    currency:
                      consignmentPriceCurrency && consignmentPriceCurrency.code,
                  }}
                  defaultMessage="Překročil jste limit automatického připojištění ({price} {currency}). Doporučujeme zásilku připojistit!\nOhledně více informací prosím kontaktujte zákaznické centrum na emailu DHLFreight.cz@dhl.com nebo na tel: +420 239 018 222."
                />
              </Typography.Text>
            </Col>
          </Row>
        )}
      {overPrice && (
        <Row gutter={[0, 20]}>
          <Col offset={3}>
            <Typography.Text type="danger" className="insurance-warning">
              <FormattedMessage
                id="consignment.insurance.overPrice"
                values={{
                  limitPrice: formatPrice(limitPrice),
                  maxPrice: formatPrice(maxPrice),
                  currency:
                    consignmentPriceCurrency && consignmentPriceCurrency.code,
                }}
                defaultMessage="Vaše zásilka překračuje povolený limit hodnoty v produktu, pro objednání prosím kontaktujte zákaznické centrum na emailu DHLFreight.cz@dhl.com nebo na tel: +420 239 018 222.\n(Do {limitPrice} {currency} je připojištěno automaticky, v případě {limitPrice} až {maxPrice} {currency} doporučujeme připojistit)"
              />
            </Typography.Text>
          </Col>
        </Row>
      )}
      {rules.insurance && (
        <Service
          disabled={disabled}
          initialValue={insurance}
          label={intl.formatMessage({
            id: "consignment.insurance",
            defaultMessage: "Připojištění",
          })}
          fieldName="insurance"
          onChange={handleSetInsurance}
          getFieldDecorator={getFieldDecorator}
          warning={
            insuranceDetail && insuranceDetail.price > 0
              ? intl.formatMessage(
                  {
                    id: "consignment.services.emptyInsurance",
                    defaultMessage:
                      "Pokud si přejete připojistit zásilku, je poplatek za tuto službu je vzhledem k atributům zásilky {insurancePrice} {insuranceCurrency}.",
                  },
                  {
                    insurancePrice: insuranceDetail.price.toFixed(2),
                    insuranceCurrency: insuranceDetail.currency,
                  }
                )
              : undefined
          }
        />
      )}
    </>
  );
}

export default Insurance;
